module.exports = __webpack_public_path__ + "static/media/S1-30-Fúria-Robótica-cod50.ef51e3ef.png";